import {Divider, Space, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Diez = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Validation</Paragraph>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '-6%', textAlign: 'center'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Luis Alfredo Hernández<br/>López</Paragraph>
            <Text className='BaseText5'>Since 2009 he has been participating in projects as a consultant of issues in process and organizational improvement and has also been administrator of government found resources. He is co-founder of the civil association named Thanatology Center and Ambulance Transfer with Human Quality, A.C.</Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>How to make a business model canvas?</li>
                <li>How to know who our customers are?</li>
                <li>Definition of the product and service</li>
                <li>Define our key activities and value proposition canvas</li>
              </ul>
            </Text>
          </Content>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="110%" height="auto" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-34.jpeg'/>
          </Content>
        </Space>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '3%', textAlign: 'center'}}>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="100%" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-35.jpg'/>
          </Content>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Joshua Hammerschlag</Paragraph>
            <Text className='BaseText5'>Director of social entrepreneurship at Tec de Monterrey, the largest private higher education institution in Mexico. He has been an entrepreneur himself as a co-founder of 2 different social enterprises.  He is a member of B Corps and B academics in Latin America.</Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>Bases of how to start a business</li>
                <li>What is the main problem, the causes and effects?</li>
                <li>How to know if the project is viable, desirable and feasible?</li>
                <li>Validate the social impact of our project</li>
              </ul>
            </Text>
          </Content>
        </Space>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Diez;
